import femaleAyahModernImage from 'assets/images/ab_test_313_gender_female.webp'
import maleAyahModernImage from 'assets/images/ab_test_313_gender_male.webp'

import { Gender } from 'root-constants'

import { TGenderOption } from '../../types'

export const AYAH_GENDER_OPTIONS = [
  {
    value: Gender.FEMALE,
    text: 'commonComponents.gender.woman',
    imageUrl: femaleAyahModernImage,
  },
  {
    value: Gender.MALE,
    text: 'commonComponents.gender.man',
    imageUrl: maleAyahModernImage,
  },
] as const satisfies readonly TGenderOption[]
